import { render, staticRenderFns } from "./Berthing.vue?vue&type=template&id=b00e8d28&scoped=true"
import script from "./Berthing.vue?vue&type=script&lang=js"
export * from "./Berthing.vue?vue&type=script&lang=js"
import style0 from "./Berthing.vue?vue&type=style&index=0&id=b00e8d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00e8d28",
  null
  
)

export default component.exports